import React, { useRef, useEffect, useState, useContext } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import '../layout/sass/_responsiveTable.scss'

import api from '../api/api';
import { BrCalendar } from './BrCalendar';
import { Dialog } from 'primereact/dialog';
import { AuthContext } from '../contexts/AuthContext';
import { DialogMedia } from '../components/DialogMedia';

export const TabelaVaf = (props) => {

    const { user } = useContext(AuthContext);
    const confirmationToast = useRef(null);
    const toast = useRef(null);
    const [dt, setDt] = useState(null);
    const [media, setMedia] = useState([]);
    const[intervaloDatas,setIntervaloDatas]=useState({});
    const [isLoading, setIsLoading] = useState(false);
    const[showListaMedia,setShowListaMedia]=useState(false);
    const [isShowInfo, setIsShowInfo] = useState(false);
    const [msgInfo, setMsgInfo] = useState([]);



    useEffect(() => {
        
        setMedia(props.data);
        setIntervaloDatas(props.intervaloDatas);                
        
        
    }, [props])

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Média Mensal</h2>
            </div>
        </div>
    );

    const formatCurrency = (value) => {
        return value.toLocaleString('pt-BR', { 
            style: 'currency', 
            currency: 'BRL' ,
            minimumFractionDigits: 2, 
            maximumFractionDigits: 2
        });
    }


    const produtoNomeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{textAlign: 'left'}}>
                    <span className="p-column-title">Produto</span>
                    <span className="table-data">{rowData.nome}</span>
                </p>
            </React.Fragment>
        );
    } 

    const mediaBodyTemplate = (rowData) => {
        return (
            <React.Fragment>  
                <p style={{textAlign: 'center'}}>
                    <span className="p-column-title">Valor Médio</span>
                    <span className="table-data">{formatCurrency(rowData.valorUn)}</span>
                </p>
            </React.Fragment>
        );
    }

    const qtdeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{textAlign: 'center'}}>
                    <span className="p-column-title">Qtde</span>
                    <span className="table-data">{rowData.total.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                </p>
            </React.Fragment>
        );
    }
    
    const unBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{textAlign: 'center'}}>
                    <span className="p-column-title">Un</span>
                    <span className="table-data">{rowData.unPadrao}</span>
                </p>
            </React.Fragment>
        );
    }

    const municipioBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{textAlign: 'left'}}>
                    <span className="p-column-title">Município</span>
                    <span className="table-data">{rowData.municipio}</span>
                </p>
            </React.Fragment>
        );
    }

    const handlePrintClick = () => {
        setShowListaMedia(true);
    };

   
    return (
        <>
        <Dialog className='p-scrollpanel-bar-y' header="Histórico" onHide={() => setIsShowInfo(false)} visible={isShowInfo} breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{width: '50vw', heigth: '5vw'}} >
            {msgInfo.map((item) => {
                return (<p><li>{new Date(item.created_at).toLocaleString()} - {item.log}</li></p>)
            })}
        </Dialog>

        <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

           

        { media.nome != '' ?
            <>
            <DialogMedia 
                    visible={showListaMedia}
                    setVisible={setShowListaMedia}
                    lista={media}
                    intervaloDatas={intervaloDatas}
                    />
            
                 <div className="p-my-0 p-dir-rev p-col">
                    <div className="p-my-0">
                        <Button
                            // textAlign="center"
                            icon="pi pi-print"
                            className="p-button-secondary"
                            style={{ width: "35px" }}
                            onClick={handlePrintClick}
                            tooltip="Gerar relatório"
                            tooltipOptions={{ position: "top" }}
                        />
                    </div>
                </div>
                </>
                :
                <></>
                }
                

                   
            <Toast ref={toast} position="bottom-right" />
            <Toast ref={confirmationToast} position="bottom-center" />
            <div className="card p-col-12 datatable-responsive-demo">
                <div className="p-fluid">
                    <DataTable
                        ref={(element) => setDt(element)}
                        header={header}
                        value={media}
                        className="p-datatable-responsive-demo"
                        emptyMessage="Nenhuma média encontrado"
                        loading={isLoading}
                        dataKey="id"
                        paginator
                        rows={10}
                        currentPageReportTemplate="Mostrando de {first} a {last} de {totalRecords} preços"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[10, 20, 30]}
                        sortField="precos" sortOrder={1}
                        removableSort
                    >
                         {/* <Column
                            field="dataInicial"
                            header="Data Inicial"
                            sortable
                            body={produtoNomeBodyTemplate}
                            filter
                            filterMatchMode="custom"
                            filterFunction={filterDate}
                            filterElement={dateFilterInicio}
                        />
                           <Column
                            field="dataFinal"
                            header="Data Final"
                            sortable
                            body={mediaBodyTemplate}
                            filter
                            filterMatchMode="custom"
                            filterFunction={filterDate}
                            filterElement={dateFilterFim}
                        /> */}
                        {/* <Column style={{ width: '12%' }}
                            field="id"
                            header="Código"
                            sortable
                            body={precoIdBodyTemplate}
                            filter
                            filterMatchMode="contains"
                            filterPlaceholder="Pesquise por Código"
                        /> */}

                         <Column
                            field="nome"
                            header="Produto"
                            sortable
                            body={produtoNomeBodyTemplate}
                            filter
                            filterMatchMode="contains"
                            filterPlaceholder="Pesquise por nome"
                        />

                         <Column
                            field="unPadrao"
                            header="Un Padrão"                            
                            body={unBodyTemplate}
                            // filter
                            // filterMatchMode="contains"
                            // filterPlaceholder="Pesquise por embalagem"
                        />

                        <Column
                            field="valorUn"
                            header="Média do Valor"
                            sortable
                            body={mediaBodyTemplate}
                            // filter
                            // filterMatchMode="contains"
                            // filterPlaceholder="Pesquise por valor"
                        />

                        <Column
                            field="municipio"
                            header="Municipio"                            
                            body={municipioBodyTemplate}
                            sortable
                            filter
                            filterMatchMode="contains"
                            filterPlaceholder="Pesquise por Municipio"
                        />

                        <Column
                            field="total"
                            header="Qtde"                            
                            body={qtdeBodyTemplate}
                            // filter
                            // filterMatchMode="contains"
                            // filterPlaceholder="Pesquise por valor"
                        />
                      
                        {/* <Column
                            header="Ações"
                            // body={actionBodyTemplate}
                        /> */}
                    </DataTable>
                </div>
            </div>
            </div>
        </>
    );
}

